<script lang="ts">
import { useSignOut } from '@nhost/vue';

export default {
  data() {
    return {};
  },
  created() {
    const { signOut } = useSignOut();
    signOut().then(() => {
      window.location.href = '/sign-in';
    });
  },
};
</script>

<template>
  <main></main>
</template>
